"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickableImage = exports.image = exports.text = exports.description = exports.userName = exports.basic = exports.wrapper = void 0;

var react_1 = require("@emotion/react");

exports.wrapper = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 20px 0;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"])));
exports.basic = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 8px;\n"])));
exports.userName = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-left: 6px;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--gray-800);\n"])));
exports.description = react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-bottom: 2px;\n  font-size: 12px;\n  color: var(--gray-500);\n\n  &:nth-of-type(3) {\n    margin-bottom: 8px;\n  }\n"])));

var text = function text() {
  var fold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  max-height: ", ";\n  word-break: break-all;\n  font-size: 15px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n"])), fold ? '72px' : 'auto');
};

exports.text = text;
exports.image = react_1.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  max-height: 100%;\n  margin-top: 8px;\n  border-radius: 4px;\n"])));
exports.clickableImage = react_1.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));